import {Injectable} from '@angular/core'
import {BehaviorSubject, Observable} from 'rxjs'

export interface PageLoadingStatus {
  isLoading: boolean
  text: string
}

@Injectable({
  providedIn: 'root',
})
export class PageLoadingStateService {
  loading$ = new BehaviorSubject({isLoading: false, text: ''})

  constructor() {}

  setIsLoading(bool: boolean, text = '') {
    this.loading$.next({isLoading: bool, text: text})
  }

  getIsLoading(): Observable<PageLoadingStatus> {
    return this.loading$
  }
}
